import { NormalizedSchema, denormalize, normalize } from 'normalizr';
import { ResourceSection } from 'data/documents';
import { ProjectTemplateTask } from 'data/templates/projects';
import { DocumentTemplate, DocumentTemplateContentSection } from '../types';
import { documentTemplateSchema } from './schema';

export interface NormalizedDocumentTemplatePayload {
  template: DocumentTemplate;
  resourceSections: {
    [key: string]: ResourceSection<Partial<ProjectTemplateTask>>;
  };
  sections: {
    [key: string]: DocumentTemplateContentSection;
  };
}

export const normalizeTemplatePayload = (
  payload: DocumentTemplate,
): NormalizedSchema<NormalizedDocumentTemplatePayload, string> =>
  normalize(payload, documentTemplateSchema);

export const denormalizePayload = (
  payload: NormalizedDocumentTemplatePayload,
): DocumentTemplate => {
  const denormalizedData = denormalize(
    { template: payload.template },
    { template: documentTemplateSchema },
    payload,
  );

  return denormalizedData.template;
};
